import { useQuery } from '@tanstack/react-query';
import { verificationApi } from '../api/verificationApi';
import { ivKeys } from '../queryKeys';
import { isRunning } from '../utils/format';

const POLL_MS = 5_000;

export function useVerificationDetail(id: string | undefined) {
  const query = useQuery({
    queryKey: ivKeys.detail(id ?? ''),
    queryFn: () => verificationApi.getVerification(id ?? ''),
    enabled: !!id,
    // Poll while the electronic check is still running.
    refetchInterval: (q) => {
      const status = q.state.data?.verification.status;
      return status && isRunning(status) ? POLL_MS : false;
    },
  });

  return { ...query, detail: query.data ?? null };
}
